<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     class="delete-demo-modal"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            
            <div class="box text-center mt-5 offset-md-3 col-sm-12 col-md-6">       
                <div class="btn btn-primary btn-lg mb-2"><app-icon :name="'check'" width="40" height="40"/></div>
                <h2>{{ $t('really_delete_demo_data') }}</h2>
                <div class="form-group row align-items-center mb-5">
                    <p class="mt-4">
                        {{ $t('all_data_inserted_to_this_point_will_be_deleted') }}
                    </p>
                    
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-primary mt-3" @click.prevent="confirmDemoDelete()">{{ $t('yes_continue') }}</button>
                    </div>
                    
                </div>
                
            </div>
            <div class="clearfix"></div>
            
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import AppLibrary from "../../../../../Helpers/AppLibrary";

    export default {
        name: "DeleteDemoModal",
        extends: AppLibrary,
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            selectedRows: Array,
            modalType: String,
        },
        data() {
            return {
                preloader: false,
                
                inputs: {
                    name: '',
                    job: '',
                    sendTo: '',
                    status: '2',
                },
                modalId: 'delete-demo-Modal',
                modalTitle: this.$t('add'),
                 
                
                
                value: {},
                tagPreloader: false,
                multiCreatePreloader: false,
            }
        },
        mounted() {
            
            
            
        },
        methods: {
            submit() {
                // This should stay here even if footer button disabled
            },
            confirmDemoDelete() {
                console.log('smazat');
                
                // dodelat 
                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: 'delete'
                }).then(response => {
                    
                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }
                    
                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });
                
                
                
                
            },
            
            
        },
    }
</script>
